import React, { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Box, Button, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ROLE_DEFINITIONS } from '../../../services/roleService';
import { DEFAULT_VIEW_AS_WRITE_ACCESS } from '../../../services/actingContext';

const LEVELS = ['org_admin', 'org_it', 'executive', 'site_manager', 'department_lead', 'team_lead'];

/**
 * Org setting `viewAs.writeAccess[viewerRole]` (Beta-1 plan P4-06, Tim C0814 Mailchimp-style
 * support mode). ON (default) = the viewer can act on the member's behalf (audited, P4-07);
 * OFF = View As is read-only for viewers at that level.
 */
export function ViewAsAccessSection({ organization, onSave, saving }) {
  const current = organization?.viewAs?.writeAccess || {};
  const [values, setValues] = useState({ ...DEFAULT_VIEW_AS_WRITE_ACCESS, ...current });
  const [dirty, setDirty] = useState(false);
  useEffect(() => { setValues({ ...DEFAULT_VIEW_AS_WRITE_ACCESS, ...(organization?.viewAs?.writeAccess || {}) }); setDirty(false); }, [organization?.id, organization?.viewAs]);

  return (
    <Accordion sx={{ mb: 2 }} defaultExpanded={false}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <VisibilityIcon color="primary" />
          <Typography variant="h6">View As access</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Members above an individual contributor can <strong>view as</strong> anyone below them (never above). With
          full access they can act on that member's behalf — every such action is recorded as the member, marked
          "entered by" the viewer, and the member is told. Switch a level to <strong>Read only</strong> to let viewers
          at that level look without changing anything (support mode).
        </Typography>
        <Stack spacing={0.5}>
          {LEVELS.map((role) => (
            <FormControlLabel
              key={role}
              control={<Switch checked={values[role] !== false} onChange={(e) => { setValues((v) => ({ ...v, [role]: e.target.checked })); setDirty(true); }} />}
              label={
                <Box>
                  <Typography variant="body2" fontWeight={600}>{ROLE_DEFINITIONS[role]?.label || role}</Typography>
                  <Typography variant="caption" color="text.secondary">{values[role] !== false ? 'Full access when viewing as a member (audited)' : 'Read only when viewing as a member'}</Typography>
                </Box>
              }
            />
          ))}
        </Stack>
        <Box sx={{ mt: 2 }}>
          <Button variant="contained" size="small" disabled={!dirty || saving} onClick={() => { onSave({ writeAccess: values }); setDirty(false); }}>
            {saving ? 'Saving…' : 'Save View As access'}
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default ViewAsAccessSection;
